export default __webpack_public_path__ + "static/media/telephone.3dedd372.svg";